import { Injectable } from "@angular/core";
import { Api, getUserInfoResponse } from "./api";
import { Util } from "./util";

@Injectable()
export class User implements getUserInfoResponse {
  notLoggedInRejection = () => {
    console.trace("not logged in");
    return Promise.reject("[trivial-error] not logged in");
  };

  get token() {
    return localStorage["api_token"];
  }

  constructor(private api: Api, private util: Util) {
    if (window["UserService"]) throw "User service must be a singleton !";
    window["UserService"] = this;
    this.getUserInfoSoonIfTokenExists();

    let match = /t=(\w+)/im.exec(window.location.search);
    if (match != null) {
      this.setToken(match[1]);
      window.location.assign(
        window.location.origin + "/?s=wx" + window.location.hash
      );
    }
  }

  public id: number = 0;
  public headimgurl: string;
  public nickname: string;
  public user_center_user_id = 0;

  public getUserInfo(silent = false) {
    return this.api.getUserInfo(silent).then((data) => {
      this.id = data.id;
      this.headimgurl = data.headimgurl;
      this.nickname = data.nickname;
      this.user_center_user_id = data.user_center_user_id;
      return data;
    });
  }

  public isLoggedIn(): boolean {
    return !!localStorage["api_token"];
  }

  /**
   * logs user in, on successful, refreshes the page
   */
  public showLogin() {
    console.trace("show login");
    if (this.util.isWeixin()) {
      window.location.assign(
        "https://wxauth.tuozhanpian.com/kanjia.php?hash=" +
          encodeURIComponent(window.location.hash)
      );
      return;
    } else {
      if (window.location.hash.indexOf("#/login") < 0) {
        sessionStorage["nonWechatLoginCallbackUrl"] = window.location.href;
        setTimeout(() => {
          window.location.hash = `#/login`;
        }, 300);
      }
      return;
    }
  }

  public setToken(token) {
    this.getUserInfoSoonIfTokenExists();
    localStorage["api_token"] = token;
  }

  private getUserInfoSoonIfTokenExists() {
    setTimeout(() => {
      if (this.token) {
        this.getUserInfo(true);
      }
    }, 500);
  }
}



// WEBPACK FOOTER //
// ./src/services/user.ts